import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DrawerNames } from '../models/drawer-names.models';

export interface DrawerEvent {
  id: DrawerNames;
  data?: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  openDrawerSubject = new Subject<DrawerEvent>();
  openDrawer$ = this.openDrawerSubject.asObservable();

  closeDrawerSubject = new Subject<DrawerNames>();
  closeDrawer$ = this.closeDrawerSubject.asObservable();

  open(drawerId: DrawerNames, data?: unknown): void {
    this.openDrawerSubject.next({ id: drawerId, data });
  }

  close(drawerId: DrawerNames): void {
    this.closeDrawerSubject.next(drawerId);
  }
}
